import { Action } from "redux";

// Shape returned by the bazaar deactivate/delete API in `popupExperience`
// when the acting owner is eligible for the pilot experience popup.
export interface PopupExperiencePayload {
    productId: number;
    title: string;
}

export const SELL_EXPERIENCE_POPUP_SHOW = "SELL_EXPERIENCE_POPUP_SHOW";

export interface SellExperiencePopupShowAction extends Action {
    readonly type: typeof SELL_EXPERIENCE_POPUP_SHOW;
    readonly productId: number;
    readonly title: string;
}

export const sellExperiencePopupShow = (
    productId: number,
    title: string,
): SellExperiencePopupShowAction => ({
    type: SELL_EXPERIENCE_POPUP_SHOW,
    productId,
    title,
});

export const SELL_EXPERIENCE_POPUP_WRITE = "SELL_EXPERIENCE_POPUP_WRITE";

export interface SellExperiencePopupWriteAction extends Action {
    readonly type: typeof SELL_EXPERIENCE_POPUP_WRITE;
    readonly productId: number;
}

export const sellExperiencePopupWrite = (productId: number): SellExperiencePopupWriteAction => ({
    type: SELL_EXPERIENCE_POPUP_WRITE,
    productId,
});

export const SELL_EXPERIENCE_POPUP_CLOSE = "SELL_EXPERIENCE_POPUP_CLOSE";

export interface SellExperiencePopupCloseAction extends Action {
    readonly type: typeof SELL_EXPERIENCE_POPUP_CLOSE;
    readonly productId: number;
}

export const sellExperiencePopupClose = (productId: number): SellExperiencePopupCloseAction => ({
    type: SELL_EXPERIENCE_POPUP_CLOSE,
    productId,
});
